export const TOGGLE_LOADER = 'TOGGLE_LOADER';

export const loader = () => ({
    type: TOGGLE_LOADER
});